export const selectedCountry = {
  placeholder: "Seleziona un paese",
};
